/* NavItemLink.jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, Route } from 'react-router-dom';
import { FontIcon, ListItem } from 'react-md';
import ReactSVG from 'react-svg';

/**
 * Due to the fact that react-router uses context and most of the components
 * in react-md use PureComponent, the matching won't work as expected since
 * the PureComponent will block the context updates. This is a simple wrapper
 * with Route to make sure that the active state is correctly applied after
 * an item has been clicked.
 */
const NavItemLink = ({
  label, to, icon, svgicon, exact,
}) => (
  <Route path={to} exact={exact}>
    {({ match }) => {
      let leftIcon;
      if (icon) {
        leftIcon = <FontIcon>{icon}</FontIcon>;
      } else if (svgicon) {
        leftIcon = (<ReactSVG
          path={svgicon}
          className="svgicon"
        />);
      }
      const className = match ? 'active' : 'non-active';

      return (
        <ListItem
          className={className}
          activeClassName="md-text--theme-secondary"
          component={Link}
          active={!!match}
          to={to}
          primaryText={label}
          leftIcon={leftIcon}
        />
      );
    }}
  </Route>
);

NavItemLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  exact: PropTypes.bool,
  icon: PropTypes.node,
  svgicon: PropTypes.node,
};
export default NavItemLink;



// WEBPACK FOOTER //
// ./src/components/NavItemLink.js